import { t as VisualEditing } from "./VisualEditing-CdJu-qkj.js";
import { StrictMode } from "react";
import { jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
/**
* The purpose of this file is to contain the logic for rendering the <VisualEditing />
* component in a way that is easy to lazy load for the `enableVisualEditing` function.
*/
let node = null, root = null, cleanup = null;
function renderVisualEditing(signal, { components, history, keepStegaOnCopy, refresh, zIndex, plugins, onPerspectiveChange, onVariantChange, onSuspiciousStega }) {
	cleanup && clearTimeout(cleanup), signal.addEventListener("abort", () => {
		cleanup = setTimeout(() => {
			root &&= (root.unmount(), null), node &&= (node.parentNode.removeChild(node), null);
		}, 1e3);
	}), node || (node = document.createElement("sanity-visual-editing"), document.body.parentNode.insertBefore(node, document.body.nextSibling)), root ||= createRoot(node), root.render(/* @__PURE__ */ jsx(StrictMode, { children: /* @__PURE__ */ jsx(VisualEditing, {
		components,
		plugins,
		history,
		keepStegaOnCopy,
		refresh,
		zIndex,
		onPerspectiveChange,
		onVariantChange,
		onSuspiciousStega,
		portal: !1
	}) }));
}
export { renderVisualEditing };

//# sourceMappingURL=renderVisualEditing-Dx077Iuu.js.map